/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import styled from 'styled-components';
import _get from 'lodash.get';

import Link from '@ntuctech/devex-tangram/Link';
import Typography from '@ntuctech/devex-tangram/Typography';

import PageContent from '../theme/PageContent';
import PageHeader from '../theme/PageHeader';
import LoginForm from './LoginForm';
import PageFooter from '../theme/PageFooter';

import { usePageContext } from '../PageContextProvider';
import { PAGE_CONTEXT } from '../../constants/app-constants';
import GA from '../../services/google-analytics-tags';
import Env from '../../services/environment';

const PageContentSC = styled(PageContent)``;

const Login = () => {
  const { setPageContext } = usePageContext();

  const handleSignup = () => {
    GA.track('Sign-in', 'Navigate to sign-up');
    setPageContext(PAGE_CONTEXT.SIGNUP);
  };

  const shouldShowSignup = () => {
    return (
      Env.realm(typeof window !== 'undefined' && _get(window, 'Auth0Config.clientID')) ===
      'NE-Digital-ID-Platform-Connection'
    );
  };

  return (
    <>
      <PageContentSC>
        <PageHeader header="Log in to your account" />
        <LoginForm />
      </PageContentSC>
      {shouldShowSignup() ? (
        <PageFooter>
          <Typography variant="body3" className="SSOPage__page-note">
            Don’t have an account?{' '}
            <Link onClick={handleSignup} href="#" data-testid="signUpPageLink">
              Sign Up
            </Link>
          </Typography>
        </PageFooter>
      ) : null}
    </>
  );
};

export default Login;
